import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Buscador({ item, menuAbierto, setCategoriaDesplegada }) {
  const [searchTerm, setSearchTerm] = useState(''); // Estado para el término de búsqueda
  const navigate = useNavigate(); // Hook para la navegación

  // Función para manejar el cambio en el input
  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Función que se ejecuta al hacer clic en el botón
  const handleBuscador = () => {
    if (!menuAbierto) {
      setCategoriaDesplegada(false);
    }
    if (searchTerm.trim()) { // Verifica que el término de búsqueda no esté vacío
      navigate(`/productos?search=${encodeURIComponent(searchTerm)}`, { state: { modo: 'search' } });
      setSearchTerm(''); // Limpia el campo de búsqueda
    }
  };

  // Función que maneja el evento de presionar Enter
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBuscador();
    }
  };

  return (
    menuAbierto ? (
      <div className="flex w-full justify-around">
        <input
          type="text"
          className="w-4/5 h-10 p-2 border-2 rounded-lg border-Negro btw:w-3/5"
          value={searchTerm}
          onChange={handleChange}
          onKeyPress={handleKeyPress} // Agregado el manejador de la tecla Enter
          placeholder="Buscar productos..."
        />
        <button
          className="w-1/5 p-2 rounded-full mx-1 text-center ml-2"
          onClick={handleBuscador}
        >
          {item}
        </button>
      </div>
    ) : (
      <div className="flex w-1/5">
        <input
          type="text"
          className="w-4/5 h-10 p-2 border-2 rounded-lg border-Negro"
          value={searchTerm}
          onChange={handleChange}
          onKeyPress={handleKeyPress} // Agregado el manejador de la tecla Enter
          placeholder="Buscar productos..."
        />
        <button
          className="w-1/5 p-2 rounded-full mx-1 text-center ml-2"
          onClick={handleBuscador}
        >
          {item}
        </button>
      </div>
    )
  );
}

export default Buscador;
